import { useState } from "react";

const navItems = [
  { label: "今日热帖", href: "#trending" },
  { label: "话题分区", href: "#zones" },
  { label: "讨论区", href: "#discussion" },
  { label: "围观热评", href: "#comments" },
  { label: "茶余饭后", href: "#teatalk" },
];

export default function TopBar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:h-[72px] md:px-6">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
              黑料八卦
            </h1>
            <span className="mt-1 text-[11px] tracking-widest text-foreground-500">
              吃瓜群众的闲聊讨论区
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <div className="flex h-9 items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3">
            <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-sm" />
            </span>
            <input
              type="text"
              placeholder="搜一搜最近的瓜"
              className="w-28 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none xl:w-40"
            />
          </div>
          <a
            href="#subscribe"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅谈资
          </a>
        </div>

        <button
          type="button"
          aria-label="展开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 lg:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-md bg-primary-500 px-3 py-2 text-center text-sm font-medium text-background-50"
            >
              订阅谈资
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}